var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VideoSlideCard',{attrs:{"text":this.slide.text,"image":this.slide.image,"title":this.slide.title,"video":this.slide.video}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }